import { Pages } from '../pages'

export enum NREvents {
  LANDING_PAGE_LOADED = 'LANDING_PAGE_LOADED',
  ERROR_PAGE_LOADED = 'ERROR_PAGE_LOADED',
  RECHARGES_HOME_PAGE_LOADED = 'RECHARGES_HOME_PAGE_LOADED',
  PLAN_SELECTION_PAGE_LOADED = 'PLAN_SELECTION_PAGE_LOADED',
  PAYMENTS_PAGE_LOADED = 'PAYMENTS_PAGE_LOADED',
  EDIT_PAGE_LOADED = 'EDIT_PAGE_LOADED',
  CONTACTS_PAGE_LOADED = 'CONTACTS_PAGE_LOADED',
  MISSING_TRANSACTION_ID = 'MISSING_TRANSACTION_ID',
  CREDBLOCK_MISSING = 'CREDBLOCK_MISSING',
  CREDBLOCK_NULL_ON_BACK = 'CREDBLOCK_NULL_ON_BACK',
  BRIDGE_CALL_FAILED = 'BRIDGE_CALL_FAILED',
  OS_VERSION_NOT_SUPPORTED = 'OS_VERSION_NOT_SUPPORTED',
  POLLING_PAGE = 'POLLING_PAGE',
  SEND_MONEY_CALL = 'SEND_MONEY_CALL',
  PWD_FAILURE = 'PWD_FAILURE',
  OPTIONS_CALL_FAILURE = 'OPTIONS_CALL_FAILURE',
  BILLER_SELECTION_PAGE_LOADED = 'BILLER_SELECTION_PAGE_LOADED',
  MORE_BILLS_PAGE_LOADED = 'MORE_BILLS_PAGE_LOADED',
  CONSUMER_IDENTIFICATION_PAGE_LOADED = 'CONSUMER_IDENTIFICATION_PAGE_LOADED',
  BILL_DETAILS_PAGE_LOADED = 'BILL_DETAILS_PAGE_LOADED',
  PAYMENTS_BOTTOM_SHEET_LOADED = 'PAYMENTS_BOTTOM_SHEET_LOADED',
  VALIDATION_URL_NULL = 'VALIDATION_URL_NULL',
}
export enum NRAttributes {
  IS_LOGGED_IN = 'isLoggedIn',
  TENANT_NAME = 'tenantName',
  ACCOUNT_ID = 'fkAccountId',
}

export const getNRPageActionEvent = (pathname: string): NREvents | null => {
  switch (pathname.split('/')[4]) {
    case Pages.LANDING:
      return NREvents.LANDING_PAGE_LOADED
    case Pages.RECHARGES_HOME:
      return NREvents.RECHARGES_HOME_PAGE_LOADED
    case Pages.PLAN_SELECTION:
      return NREvents.PLAN_SELECTION_PAGE_LOADED
    case Pages.CHECKOUT:
      return NREvents.PAYMENTS_PAGE_LOADED
    case Pages.EDIT_CONNECTION:
      return NREvents.EDIT_PAGE_LOADED
    case Pages.CONTACTS:
      return NREvents.CONTACTS_PAGE_LOADED
    case Pages.ERROR:
      return NREvents.ERROR_PAGE_LOADED
    case Pages.BILLER_SELECTION:
      return NREvents.BILLER_SELECTION_PAGE_LOADED
    case Pages.ALL_BILLS_RECHARGES:
      return NREvents.MORE_BILLS_PAGE_LOADED
    case Pages.CONSUMER_IDENTIFICATION:
      return NREvents.CONSUMER_IDENTIFICATION_PAGE_LOADED
    case Pages.BILL_DETAILS:
      return NREvents.BILL_DETAILS_PAGE_LOADED
    default:
      return null
  }
}
